/* global axios */
import ApiClient from './ApiClient';

class LeadScoresAPI extends ApiClient {
  constructor() {
    super('pipeline_cards', { accountScoped: true });
  }

  // As rotas de lead score vivem sob o namespace /pipeline/cards/:id (não
  // /pipeline_cards/:id, que é o resource CRUD). Espelha o remap já feito em
  // getDistribution — sem isso o backend responde 404.
  recalculate(pipelineCardId) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    return axios.post(`${baseUrl}/${pipelineCardId}/lead_scores/recalculate`);
  }

  override(pipelineCardId, score) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    return axios.post(`${baseUrl}/${pipelineCardId}/lead_scores/override`, {
      score,
    });
  }

  getDistribution() {
    // Distribution endpoint is under /pipeline namespace, not /pipeline_cards
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline');
    return axios.get(`${baseUrl}/lead_scores/distribution`);
  }
}

export default new LeadScoresAPI();
